import * as actionsType from '../../actions/actionsTypes/profiliOrariActionType';

export const InitialStateProfiliOrari = {
    profiliOrariResponse: [],
    profiliOrariTotaliIndividui: [],
};

export const profiliOrariReducer = (state = InitialStateProfiliOrari, action) => {

    switch (action.type){

        case actionsType.GET_RECUPERO_PROFILI_ORARI_SUCCESS :
            // let _copyState = [...state.profiliOrariTotaliIndividui];
            //action.profiloOrario.forEach((value,key) => {
                // _copyState.push({idAnagrafica: key, profiliOrari: value});
            //});
            return{
                ...state,
                profiliOrariTotaliIndividui: [...state.profiliOrariTotaliIndividui, action.profiloOrario]
            };

        case actionsType.GET_PROFILO_ORARIO_SINGOLO_INDIVIDUO_SUCCESS :
            return {
                ...state,
                profiliOrariResponse: action.profiliOrari
            };

        case actionsType.ADD_PROFILO_ORARIO_SUCCESS :
            return {
                ...state,
                profiliOrariResponse: [...state.profiliOrariResponse, action.profiliOrariResponse],
            };

        case actionsType.ADD_PROFILO_ORARIO_FAIL :
            return state;

        case actionsType.INIT_PROFILI_ORARI:
            return {
                profiliOrariResponse: [],
                profiliOrariTotaliIndividui: [],
            };

        case actionsType.INIT_PROFILI_ORARI_RESPONSE:
            return {
                ...state,
                profiliOrariResponse: []
            };

        default:
            return state;
    }
};

